'use client';

import React from 'react';
import { Line, LineChart, XAxis } from 'recharts';
import { ChartConfig, ChartContainer, ChartTooltip } from '@/components/ui/chart';
import CustomTooltip from './CustomTooltip';

interface LineProps {
  data: Array<{ value: number }>;
  stroke: string;
  strokeWidth?: number;
  height?: string;
  type?: 'monotone' | 'linear' | 'step' | 'stepBefore' | 'stepAfter' | 'natural';
  showGrid?: boolean;
  showTooltip?: boolean;
  showXAxis?: boolean;
  xAxisKey?: string;
  xAxisFormatter?: (value: any) => string;
}

const LineChartComponent: React.FC<LineProps> = ({
  data,
  stroke,
  strokeWidth = 2,
  height = '100%',
  type = 'natural',
  showTooltip = true,
  showXAxis = false,
  xAxisKey = 'index',
  xAxisFormatter
}) => {
  // 为数据添加索引，用于 X 轴
  const chartData = data.map((item, index) => ({
    ...item,
    index: index + 1
  }));

  const chartConfig: ChartConfig = {
    value: {
      label: 'Value',
      color: stroke
    }
  };

  return (
    <div style={{ height }}>
      <ChartContainer config={chartConfig} className="h-full w-full">
        <LineChart accessibilityLayer data={chartData}>
          {showXAxis && (
            <XAxis
              dataKey={xAxisKey}
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              tickFormatter={xAxisFormatter || (value => value.toString())}
            />
          )}
          {showTooltip && <ChartTooltip cursor={false} content={CustomTooltip} />}
          <Line dataKey="value" type={type} stroke={stroke} strokeWidth={strokeWidth} dot={false} />
        </LineChart>
      </ChartContainer>
    </div>
  );
};

export default LineChartComponent;
